import React, {createContext, Component} from 'react'
import {connect} from 'react-redux'
import {createSelector} from 'reselect'
import _ from 'lodash'
import getMessage , {createGetMessage} from "../../message";

const MessageContext = createContext({
    locale: null,
    msg: messageCode => messageCode
})

class MessageProvider extends Component {
    render() {
        let {children, messageContext} = this.props
        return (
            <MessageContext.Provider value={messageContext}>
                {children}
            </MessageContext.Provider>
        )
    }
}

let getMessageContext = createSelector(
    [
        state => state.message.defaultLocale,
        state => state.message.allMessages.data,
        state => state.message.defaultMessages
    ],
    (locale, allMessages, defaultMessages) => {
        let localeMessages = _.chain(allMessages)
            .filter(m => m.langCd === locale)
            .filter(m => m.useYn !== 'N')
            .keyBy('msgCd')

        let messages = {
            ...defaultMessages,
            ...localeMessages
        }

        return {
            locale,
            msg: (messageCode) => {
                return messages[messageCode]
            }
        }
    }
)


MessageProvider = connect(
    state => {
        return {
            messageContext: getMessageContext(state)
        }
    }
)(MessageProvider)

export default MessageProvider

const defaultMapMessageToProps = (createGetMessage) => {
    return {
        msg: createGetMessage(''),
        commonMsg: createGetMessage
    }
}

export const provideGetMessage = (Comp) => {
    return class MessageConsumer extends Component {
        constructor(props) {
            super(props)
            this.renderComponent = this.renderComponent.bind(this)
        }

        renderComponent(messageContext) {
            let {msg} = messageContext

            return (
                <Comp {...this.props}
                    getMessage={getMessage}

                />
            )
        }

        render() {
            return (
                <MessageContext.Consumer>
                    {this.renderComponent}
                </MessageContext.Consumer>
            )

        }
    }
}